import { Box, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const SeparatorContainer = styled(Box)({
  gridColumn: "1",
  display: "flex",
  minWidth: 0,
});

export const SeparatorText = styled(Box)(({ theme }) => ({
  fontSize: "12px",
  color: colors.text.white,
  fontWeight: 600,
  fontFamily: "Sora",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "8px",
  backgroundColor: colors.primary.main,
  borderRadius: "8px",
  minWidth: 0,
  width: "100%",
  transition: "font-size 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
